import type { ReadonlyURLSearchParams } from 'next/navigation';

import { defaultLocale } from '~i18n/constants';
import { isLocale } from '~i18n/guard';
import { getAppUrl } from '~utils/host';

export const getLocalizedUrl = (
	searchParams: ReadonlyURLSearchParams | URLSearchParams,
	pathname: string,
	locale: string,
	targetOrigin?: string // sfw or nsfw origin when need to redirect
): string => {
	const baseUrl = targetOrigin || getAppUrl();
	const appUrl = new URL(baseUrl);
	const searchString = searchParams.toString()
		? `?${searchParams.toString()}`
		: '';
	if (locale !== defaultLocale) {
		appUrl.hostname = `${locale}.${appUrl.hostname}`;
	}

	return appUrl.toString().replace(/\/$/, '') + pathname + searchString;
};

export const getLocale = (host: string) => {
	const [locale] = host.split('.');

	return isLocale(locale) ? locale : defaultLocale;
};
